// extracted by mini-css-extract-plugin
export default {"sliderdiv":"Slider_sliderdiv__EBOOP","mainsliderdiv":"Slider_mainsliderdiv__MHvYl"};